export default {
  state: {
    userId: "", // ID
    username: "", // 名字
    userPic: "", // 图片
    isProducer: "", // 是否制作人
    producerPic: "", // 制作人艺术照
    producerName: "", // 制作人艺名
    titleName: "", // 制作人头衔
  },
  getters: {
    userId: (state) => state.userId,
    username: (state) => state.username,
    userPic: (state) => state.userPic,
    isProducer: (state) => state.isProducer,
    producerName: (state) => state.producerName,
    titleName: (state) => state.titleName,
  },
  mutations: {
    setUserId: (state, userId) => {
      state.userId = userId;
    },
    setUsername: (state, username) => {
      state.username = username;
    },
    setUserPic: (state, userPic) => {
      state.userPic = userPic;
    },
    setIsProducer: (state, isProducer) => {
      state.isProducer = isProducer;
    },
    setProducerName: (state, producerName) => {
      state.producerName = producerName;
    },
    setTitleName: (state, titleName) => {
      state.titleName = titleName;
    },
    
  },
};
